import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../Api/apiClient';
import { X } from 'lucide-react';
// Import Icons
import editProfileIcon from '../../Assets/icon/editProfileIcon.png';
import keyIcon from '../../Assets/icon/keyIcon.png';
import GetSuppportIcon from '../../Assets/icon/GetSuppportIcon.png';
import BillsIcon from '../../Assets/icon/BillsIcon.png';
import SubscriptionIcon from '../../Assets/icon/SubscriptionIcon.png';
import PreferenceIcon from '../../Assets/icon/PreferenceIcon.png';
import PublishTenderAlert from '../Alert/PublishTenderAlert';
import ProfileUpdateAlert from '../Alert/ProfileUpdateAlert';

const WelcomeInDashboard = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [packageStatus, setPackageStatus] = useState({
    package_status: '',
    current_package: '',
    user_name: '',
  });

  const user_type = localStorage.getItem('user_type');
  useEffect(() => {
    const fetchProfileData = async () => {
      let url = '/user/profile';
      if (user_type === 'affiliator') {
        url = '/affiliator/profile';
      }
      try {
        const response = await apiClient.get(url);
        setUserName(response.data.data.full_name);
        setPackageStatus(response.data.data);
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };
    fetchProfileData();
  }, []);

  const handleRenew = () => {
    navigate('/pricingPackages', { state: { FromRenew: 'FromRenew' } });
    window.scrollTo(0, 0);
  };

  const userType = localStorage.getItem('user_type');

  return (
    <div className="md:p-6 p-2 container mx-auto">
      <ProfileUpdateAlert userName={userName} />
      {/* Dashboard Sections */}
      <div className="flex flex-col md:flex-row justify-between md:text-xs text-xs md:gap-4 gap-4 w-full">
        {/* Left Section */}
        <div className="w-full md:w-1/2">
          {user_type === 'affiliator' ? (
            <div className="flex flex-col md:flex-row gap-4">
              <div className="grid grid-cols-1 gap-4 md:gap-4 p-2 bg-gray-50 border shadow rounded-lg w-full">
                <h1 className="font-semibold">Profile Management</h1>
                {[
                  {
                    icon: editProfileIcon,
                    label: 'Edit Profile',
                    path: '/profile',
                  },
                  {
                    icon: keyIcon,
                    label: 'Change Password',
                    path: '/change-password',
                  },
                  {
                    icon: GetSuppportIcon,
                    label: 'Get Support',
                    path: '/contactUs',
                  },
                  {
                    icon: PreferenceIcon,
                    label: 'Verify Profile',
                    path: '/verify-profile',
                  },
                ].map(({ icon, label, path, classNames }, index) => (
                  <button
                    key={index}
                    onClick={() => path !== '#' && navigate(path)}
                    className={`flex items-center gap-2 text-gray-600 hover:text-gray-800 ${classNames}`}
                  >
                    <img src={icon} alt={label} className="w-4" />
                    {label}
                  </button>
                ))}
              </div>
              <div className="grid grid-cols-1 gap-4 md:gap-4 md:p-4 p-2 bg-gray-50 border shadow rounded-lg w-full">
                <h1 className="font-semibold">Tender Publishing Request</h1>
                {[
                  {
                    icon: BillsIcon,
                    label: 'Tender Publish',
                    path: '/tenderpublish',
                    classNames: '',
                  },
                  {
                    icon: BillsIcon,
                    label: 'View & Edit My Tender',
                    path: '/editMyTender',
                  },

                  {
                    icon: editProfileIcon,
                    label: 'My Favorite',
                    path: '/myfavorite',
                    classNames: 'hidden',
                  },

                  {
                    icon: BillsIcon,
                    label: 'View All My Published Tender',
                    path: '/view-all-my-publish-tender',
                    classNames: '',
                  },
                ].map(({ icon, label, path, classNames }, index) => (
                  <button
                    key={index}
                    onClick={() => path !== '#' && navigate(path)}
                    // className="flex items-center gap-2 text-gray-600 hover:text-gray-800"
                    className={`flex items-center gap-2 text-gray-600 hover:text-gray-800 ${classNames}`}
                  >
                    <img src={icon} alt={label} className="w-4" />
                    {label}
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div className="flex flex-col md:flex-row gap-4">
              <div className="grid grid-cols-1 gap-4 md:gap-4 md:p-4 p-2 bg-gray-50 border shadow rounded-lg w-full">
                <h1 className="font-semibold">Profile Management</h1>
                {[
                  {
                    icon: editProfileIcon,
                    label: 'Edit Profile',
                    path: '/profile',
                  },
                  {
                    icon: keyIcon,
                    label: 'Change Password',
                    path: '/change-password',
                  },
                  {
                    icon: GetSuppportIcon,
                    label: 'Get Support',
                    path: '/contactUs',
                  },

                  {
                    icon: editProfileIcon,
                    label: 'My Favorite',
                    path: '/myfavorite',
                    classNames: 'hidden',
                  },
                ].map(({ icon, label, path, classNames }, index) => (
                  <button
                    key={index}
                    onClick={() => path !== '#' && navigate(path)}
                    className={`flex items-center gap-2 text-gray-600 hover:text-gray-800 ${classNames}`}
                  >
                    <img src={icon} alt={label} className="w-4" />
                    <p  className="text-tenderLogoColor font-semibold hover:underline">{label}</p>
                  </button>
                ))}
              </div>
              <div className="grid grid-cols-1 gap-4 md:gap-4 md:p-4 p-2 bg-gray-50 border shadow rounded-lg w-full">
                <h1 className="font-semibold">Tender Publishing Request</h1>
                {[
                  {
                    icon: BillsIcon,
                    label: 'Tender Publish',
                    path: '/tenderpublish',
                    classNames: '',
                  },
                  {
                    icon: BillsIcon,
                    label: 'View & Edit My Tender',
                    path: '/editMyTender',
                  },

                  {
                    icon: editProfileIcon,
                    label: 'My Favorite',
                    path: '/myfavorite',
                    classNames: 'hidden',
                  },

                  {
                    icon: BillsIcon,
                    label: 'View All My Published Tender',
                    path: '/view-all-my-publish-tender',
                    classNames: '',
                  },
                ].map(({ icon, label, path, classNames }, index) => (
                  <button
                    key={index}
                    onClick={() => path !== '#' && navigate(path)}
                    // className="flex items-center gap-2 text-gray-600 hover:text-gray-800"
                    className={`flex items-center gap-2 text-gray-600 hover:text-gray-800 ${classNames}`}
                  >
                    <img src={icon} alt={label} className="w-4" />
                    <p  className="text-tenderLogoColor font-semibold hover:underline">{label}</p>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
        {/* Right Section */}
        <div className="w-full md:w-1/2">
          {user_type === 'affiliator' ? (
            <div className="border rounded-lg  shadow-md w-full flex flex-wrap md:flex-nowrap">
              <div className="flex-1 bg-white ml-3 mt-3">
                <div className="space-y-3 text-lg font-bold">
                  {' '}
                  <p className="text-green-500 ">Total Earn</p>{' '}
                  <p className=" text-green-500 ">
                    {packageStatus.total_earned || 0}
                  </p>{' '}
                  <p className="text-red-500 mt-2">Total Withdraw</p>{' '}
                  <p className=" text-red-500 ">
                    {packageStatus.total_withdraw || 0}
                  </p>{' '}
                </div>
              </div>

              <div className="flex-1 bg-[#f8f8f8] text-center mt-3">
                <p className="text-black  m-2 text-2xl">
                  {packageStatus.account_wallet || 0}
                </p>
                <button
                  className="text-blue-500 text-sm mt-4 hover:underline"
                  onClick={() => {
                    navigate('/history');
                  }}
                >
                  History ➡
                </button>
              </div>
            </div>
          ) : (
            <div className="border bg-gray-50 p-4 rounded-lg shadow w-full">
              {/* Main Container */}
              <div className="flex gap-4 items-center">
                {/* Left Side: Package Status */}
                <div className="flex flex-col items-center text-lg font-bold">
                  <span
                    className={`w-20 h-20 rounded-full border flex items-center justify-center text-sm capitalize ${
                      packageStatus?.package_status?.toLowerCase() === 'active'
                        ? 'border-green-500 bg-green-100 text-green-500'
                        : 'border-red-500 bg-red-100 text-red-500'
                    }`}
                  >
                    {packageStatus?.package_status || 'N/A'}
                  </span>
                </div>

                {/* Right Side: Package Details & Actions */}
                <div className="flex-1 text-xs">
                  {packageStatus?.package_status ? (
                    packageStatus.package_status.toLowerCase() === 'expired' ? (
                      <h2 className="text-red-500 text-sm">
                        Your package has expired.{' '}
                        <span
                          onClick={() => navigate('/pricingPackages')}
                          className="underline text-blue-600 cursor-pointer hover:text-blue-800"
                        >
                          Renew now
                        </span>
                      </h2>
                    ) : (
                      <div>
                        <h2 className="text-sm font-semibold text-gray-700">
                          {/* Your Package: {packageStatus.package_status} */}
                          Your Package: {packageStatus.current_package}
                        </h2>
                        {/* <p className="text-gray-500">
                          Plan: {packageStatus.current_package}
                        </p> */}
                        <p className="text-red-500 text-xl">
                          Expiration Date:{' '}
                          <span className="text-green-500 font-medium">
                            {packageStatus?.sub_expired
                              ? new Date(
                                  packageStatus.sub_expired
                                ).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric',
                                })
                              : 'N/A'}
                          </span>
                        </p>
                      </div>
                    )
                  ) : (
                    <h2 className="text-red-500 text-sm">
                      You don't have any package.{' '}
                      <span
                        onClick={() => navigate('/pricingPackages')}
                         className="text-orange-500 font-semibold hover:underline ml-1"
                      >
                        Buy now
                      </span>
                    </h2>
                  )}

                  {/* User Preferences */}
                  <h2 className="mt-2 text-gray-600">
                    Selected Category: {packageStatus.sub_sector_name || 'N/A'}{' '}
                    <span
                      onClick={() => navigate('/changePreferences')}
                       className="text-tenderLogoColor font-semibold hover:underline"
                    >
                      Change
                    </span>
                  </h2>
                </div>
              </div>

              {/* Divider */}
              <div className="h-px w-full bg-gray-300 my-2"></div>

              {/* Footer: Additional Actions */}
              <div className="">
                <div className="flex text-xs  items-center justify-center gap-4">
                  {[
                    {
                      icon: SubscriptionIcon,
                      label: 'Pricing/Renew',
                      path: '/pricingPackages',
                    },
                    {
                      icon: BillsIcon,
                      label: 'Bill Status',
                      path: '/billstatus',
                    },
                    {
                      icon: GetSuppportIcon,
                      label: 'Feedback',
                      path: '/feedBackPage',
                    },
                    ...(userType === 'end_user'
                      ? [
                          {
                            icon: GetSuppportIcon,
                            label: 'My Favorite',
                            path: '/myFavorite',
                          },
                        ]
                      : []),
                  ].map(({ icon, label, path }, index) => (
                    <button
                      key={index}
                      onClick={() => navigate(path)}
                      className="flex items-center gap-2 text-gray-600 hover:text-gray-800"
                    >
                      <img src={icon} alt={label} className="w-3" />
                      <p  className="text-tenderLogoColor font-semibold hover:underline">{label}</p>
                    </button>
                  ))}
                </div>

                {/* Divider */}
                {/* <div className="h-auto w-px bg-gray-300"></div> */}

                {/* Right Side: Text Info */}

                {/* <ul className="text-[10px] text-blue-800 leading-relaxed space-y-1">
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600">●</span>
                      Tenderwise ইতিপূর্বে রেজিস্ট্রেশন।
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600">●</span>
                      ফোন নম্বর অবশ্যই কান্ট্রি কোডসহ দিতে হবে।
                    </li>
                  </ul> */}
                {/* <div className="text-end">
                  <div className="text-lg font-medium text-gray-500">
                    Current Plan
                  </div>
                  <div className="text-gray-400 text-xs">
                    {packageStatus.current_package || 'N/A'}
                  </div>

                  <div className="mt-2 text-xs text-gray-500">
                    {packageStatus?.package_status?.toLowerCase() ===
                    'active' ? (
                      <>
                        <span className="font-medium">Expiration Date:</span>{' '}
                        <span className="text-[#6AC85E] text-xs">
                          {packageStatus?.sub_expired
                            ? new Date(
                                packageStatus.sub_expired
                              ).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                              })
                            : 'N/A'}
                        </span>
                      </>
                    ) : (
                      <button
                        onClick={handleRenew}
                        className="bg-orange-400 hover:bg-orange-500 text-white px-4 py-1 rounded-md text-xs"
                      >
                        Renew now
                      </button>
                    )}
                  </div>
                </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomeInDashboard;
